import type { OnboardingStepId, SelectOption } from "./types";

export const ONBOARDING_STEPS: Array<{
  id: OnboardingStepId;
  title: string;
  description: string;
}> = [
  {
    id: "basics",
    title: "Basics",
    description: "Tell us who you are and where you operate.",
  },
  {
    id: "coreProfile",
    title: "Core Profile",
    description: "Explain what you do and who you support.",
  },
  {
    id: "strategicFocus",
    title: "Strategic Focus",
    description: "Choose the themes that best describe your work.",
  },
  {
    id: "fundingGoals",
    title: "Funding Goals",
    description: "Set your funding preferences and timing.",
  },
  {
    id: "boostMatches",
    title: "Boost Matches",
    description: "Optionally share your site or supporting documents.",
  },
];

export const ORGANIZATION_TYPE_OPTIONS: SelectOption[] = [
  "Limited Company (Ltd)",
  "Sole Trader",
  "CIC",
  "Charity",
  "Nonprofit (Unregistered)",
  "University / Research Institution",
  "Public Body",
  "Partnership",
  "Cooperative / Association",
].map((value) => ({ value, label: value }));

export const OPERATING_SCOPE_OPTIONS: SelectOption[] = [
  "Local",
  "Regional",
  "National",
  "International",
].map((value) => ({ value, label: value }));

export const OPERATING_YEARS_OPTIONS: SelectOption[] = [
  "Pre-launch",
  "Under 1 year",
  "1-3 years",
  "3-5 years",
  "5+ years",
].map((value) => ({ value, label: value }));

export const ANNUAL_TURNOVER_OPTIONS: SelectOption[] = [
  "Pre-revenue",
  "Under £50k",
  "£50k-£250k",
  "£250k-£1m",
  "£1m+",
].map((value) => ({ value, label: value }));

export const PRIMARY_BENEFICIARY_SUGGESTIONS = [
  "Startups",
  "SMEs",
  "Young people",
  "Local residents",
  "Researchers",
  "Schools",
  "Businesses",
  "Vulnerable adults",
  "Rural communities",
  "Other (custom)",
];

export const FOCUS_THEME_GROUPS = [
  {
    label: "Innovation & Business",
    options: [
      "Technology / SaaS",
      "AI / Data",
      "Product Development",
      "R&D / Research",
      "Commercialisation",
      "Business Growth",
    ],
  },
  {
    label: "Community & Social Impact",
    options: [
      "Community Development",
      "Social Enterprise",
      "Mental Health",
      "Youth Development",
      "Skills & Training",
      "Employment Support",
      "Equality & Inclusion",
    ],
  },
  {
    label: "Environment & Infrastructure",
    options: [
      "Climate & Sustainability",
      "Biodiversity",
      "Regeneration",
      "Property & Built Environment",
    ],
  },
  {
    label: "Health & Science",
    options: [
      "Public Health",
      "Medical Research",
      "Life Sciences",
    ],
  },
  {
    label: "Education & Culture",
    options: [
      "Education",
      "Higher Education / Research",
      "Arts & Culture",
      "Sport",
    ],
  },
];

export const FUNDING_TYPE_OPTIONS: SelectOption[] = [
  "Grant",
  "Crowdfunding",
  "Equity Investment",
  "Loan",
  "Award / Fellowship",
].map((value) => ({ value, label: value }));

export const FUNDING_AMOUNT_OPTIONS: SelectOption[] = [
  "Under £5k",
  "£5k-£25k",
  "£25k-£100k",
  "£100k-£500k",
  "£500k+",
].map((value) => ({ value, label: value }));

export const FUNDING_TIMELINE_OPTIONS: SelectOption[] = [
  "ASAP",
  "Within 3-6 months",
  "6-12 months",
  "Just exploring",
].map((value) => ({ value, label: value }));

export const ONBOARDING_ACCEPTED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];
